import baseProductFieldMapFactory from '../mappers/baseProductFieldMapFactory'
import applyMap from './applyMap'

export default function applyFieldMapper(requestedFieldMap = {}, store, product) {
  const alteredProduct = JSON.parse(JSON.stringify(product))

  // Generate the base product mappings object.
  const baseProductMap = baseProductFieldMapFactory(
    store.getters['products/getMap']('taxonomy'),
    store.getters['products/getMap']('variable')
  )

  // Apply the base mappings that get applied to all products.
  let baseMappedProduct = applyMap(baseProductMap, alteredProduct, store)

  if (requestedFieldMap !== '') {
    // Apply the specific requested mapping to the product and return the result.
    const additionalMap = applyMap(requestedFieldMap, baseMappedProduct, store)

    return additionalMap
  } else {
    return baseMappedProduct
  }
}
